import { Country, City, Pagination, EnumCollectionKind, Collection } from 'src/types';
import useQuery from './useQuery';
import { ApiRoutes } from 'src/lib/routes';

const useFetchCountryOrCityCollections = (
  record: City | Country | undefined,
  recordType: 'City' | 'Country'
) => {
  const { data: activityCollectionData } = useQuery<{
    data: Collection[];
    pagination: Pagination;
  }>(
    record
      ? ApiRoutes.apiCollectionsRoute(
          {},
          {
            view: 'activity',
            q: {
              city_id_eq: recordType === 'City' ? record.id : null,
              country_id_eq: recordType === 'Country' ? record.id : null,
              by_city_featured:
                recordType === 'Country'
                  ? '1'
                  : (record.featuredActivityTagCollectionIds || []).join(','),
              kind_eq: EnumCollectionKind.Activity,
              options_count_gt: 0,
              published_supplier_activity_options_prices_price_cents_gt: 0,
              s: 'views_count desc',
            },
            per_page: 20,
          }
        ).toUrl()
      : null
  );

  const { data: listCollectionData } = useQuery<{
    data: Collection[];
    pagination: Pagination;
  }>(
    record
      ? ApiRoutes.apiCollectionsRoute(
          {},
          {
            view: 'standard',
            q: {
              city_id_eq: recordType === 'City' ? record.id : null,
              country_id_eq: recordType === 'Country' ? record.id : null,
              kind_eq: EnumCollectionKind.List,
              options_count_gt: 0,
              published_supplier_activity_options_prices_price_cents_gt: 0,
              s: 'views_count desc',
            },
            per_page: 20,
          }
        ).toUrl()
      : null
  );

  const { data: locationCollectionData } = useQuery<{
    data: Collection[];
    pagination: Pagination;
  }>(
    record && recordType === 'City'
      ? ApiRoutes.apiCollectionsRoute(
          {},
          {
            view: 'location',
            q: {
              city_id_eq: record.id,
              kind_eq: EnumCollectionKind.Location,
              by_city_featured: (record.featuredLocationCollectionIds || []).join(','),
              options_count_gt: 0,
              published_supplier_activity_options_prices_price_cents_gt: 0,
              s: 'views_count desc',
            },
            per_page: 20,
          }
        ).toUrl()
      : null
  );

  const { data: activityCollections = [] } = activityCollectionData || {};
  const { data: listCollections = [] } = listCollectionData || {};
  const { data: locationCollections = [] } = locationCollectionData || {};

  return {
    locationCollections: locationCollections,
    listCollections: listCollections,
    activityCollections: activityCollections,
  };
};

export default useFetchCountryOrCityCollections;
